import { code } from "@spscommerce/utils";

export const SpsAutocompleteExamples = {
    basic: {
        label: "Basic",
        examples: {
            basic: {
                template: code`
                    <sps-autocomplete [suggestions]="colors" [(ngModel)]="color" placeholder="Enter a color" id="basic">
                    </sps-autocomplete>
                `,
                class: code`
                    class DemoComponent {
                        color: string;
                        colors = ["red", "blue", "green"];
                    }
                `,
            },
            disabled: {
                template: code`
                    <sps-autocomplete [suggestions]="colors" [(ngModel)]="color" disabled id="disabled">
                    </sps-autocomplete>
                `,
                class: code`
                    class DemoComponent {
                        color: string;
                        colors = ["red", "blue", "green"];
                    }
                `,
            },
            spsLabel: {
                template: code`
                    <form [formGroup]="form">
                        <sps-label for="color">Color</sps-label>
                        <sps-autocomplete [suggestions]="colors" formControlName="color">
                        </sps-autocomplete>
                    </form>
                `,
                class: code`
                    class DemoComponent implements OnInit {
                        form: FormGroup;

                        constructor(private fb: FormBuilder) {}

                        ngOnInit() {
                            this.form = this.fb.group({
                                color: ["Delete me", Validators.required]
                            });
                        }
                    }
                `
            },
        }
    },
    async: {
        label: "Async",
        examples: {
            func: {
                template: code`
                    <sps-autocomplete [suggestions]="colorSearch"></sps-autocomplete>
                `,
                class: code`
                    class DemoComponent {
                        colorSearch(search: string) {
                            return [ "red", "blue", "green" ];
                        }
                    }
                `
            },
            debounce: {
                description: code`<p>Custom debounce</p>`,
                template: code`
                    <sps-autocomplete [suggestions]="colorSearch" [searchDebounce]="0"></sps-autocomplete>
                `,
                class: code`
                    class DemoComponent {
                        colorSearch(search: string) {
                            return [ "red", "blue", "green" ];
                        }
                    }
                `
            },
            promise: {
                template: code`
                    <sps-autocomplete [suggestions]="colorSearch"></sps-autocomplete>
                `,
                class: code`
                    class DemoComponent {
                        colorSearch(search: string) {
                            return new Promise((resolve, reject) => {
                                resolve([ "red", "blue", "green" ]);
                            });
                        }
                    }
                `
            },
            observable: {
                template: code`
                    <sps-autocomplete [suggestions]="colorSearch"></sps-autocomplete>
                `,
                class: code`
                    class DemoComponent {
                        colorSearch(search: string) {
                            return of([ "red", "blue", "green" ]);
                        }
                    }
                `
            },
        }
    }
};
